.backdrop {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1.25rem;
  background:
    radial-gradient(circle at 20% 15%, rgba(0, 35, 111, 0.06), transparent 45%),
    radial-gradient(circle at 80% 85%, rgba(0, 106, 97, 0.06), transparent 45%),
    #f8f9ff;
}

.card {
  width: 100%;
  max-width: 480px;
  background: #ffffff;
  border: 1px solid #dce9ff;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 20px 50px rgba(13, 28, 46, 0.08);
}

.brandHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.25rem;
}

.brandGroup {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.brandLogo {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(135deg, #00236f 0%, #1e3a8a 100%);
  color: #ffffff;
  font-weight: 800;
  font-size: 1.05rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-display, 'Manrope', sans-serif);
}

.brandTitle {
  font-family: var(--font-display, 'Manrope', sans-serif);
  font-size: 1.15rem;
  font-weight: 800;
  color: #00236f;
  margin: 0;
  letter-spacing: -0.02em;
}

.brandSubtitle {
  font-size: 0.76rem;
  color: #444651;
  margin: 0.15rem 0 0 0;
}

.pilotBadge {
  font-size: 0.68rem;
  font-weight: 700;
  padding: 0.25rem 0.6rem;
  border-radius: 999px;
  background: #e6f7f5;
  border: 1px solid #86f2e4;
  color: #006a61;
  letter-spacing: 0.04em;
}

.tabSwitcher {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.4rem;
  background: #eff4ff;
  padding: 0.3rem;
  border-radius: 10px;
  border: 1px solid #dce9ff;
  margin-bottom: 1.4rem;
}

.tabBtn {
  border: none;
  background: transparent;
  color: #444651;
  font-size: 0.86rem;
  font-weight: 600;
  padding: 0.6rem 0.75rem;
  border-radius: 7px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.tabBtnActive {
  background: #ffffff;
  color: #00236f;
  font-weight: 700;
  box-shadow: 0 2px 8px rgba(13, 28, 46, 0.08);
}

.sectionTitle {
  font-family: var(--font-display, 'Manrope', sans-serif);
  font-size: 1.1rem;
  font-weight: 800;
  color: #0d1c2e;
  margin: 0 0 0.35rem 0;
  letter-spacing: -0.015em;
}

.sectionDesc {
  font-size: 0.84rem;
  color: #444651;
  line-height: 1.5;
  margin: 0 0 1.25rem 0;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 0.95rem;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.label {
  font-size: 0.78rem;
  font-weight: 600;
  color: #444651;
  letter-spacing: 0.02em;
}

.input {
  background: #f8f9ff;
  border: 1px solid #c5c5d3;
  border-radius: 8px;
  padding: 0.68rem 0.85rem;
  color: #0d1c2e;
  font-size: 0.92rem;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.input:focus {
  background: #ffffff;
  border-color: #00236f;
  box-shadow: 0 0 0 3px rgba(0, 35, 111, 0.1);
}

.inputReadonly {
  background: #eff4ff;
  color: #444651;
  cursor: not-allowed;
}

.submitBtn {
  margin-top: 0.35rem;
  background: linear-gradient(135deg, #00236f 0%, #1e3a8a 100%);
  color: #ffffff;
  font-weight: 700;
  font-size: 0.92rem;
  border: none;
  border-radius: 9px;
  padding: 0.8rem 1rem;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(0, 35, 111, 0.22);
  transition: transform 0.1s ease, opacity 0.15s ease;
}

.submitBtn:disabled {
  opacity: 0.6;
  cursor: wait;
}

.errorBox {
  padding: 0.85rem 1rem;
  border-radius: 10px;
  background: #ffdad6;
  border: 1px solid #ffb4ab;
  color: #ba1a1a;
  font-size: 0.84rem;
  line-height: 1.5;
}

.restrictedPublicBox {
  padding: 1rem 1.1rem;
  border-radius: 12px;
  background: #fef3c7;
  border: 1px solid #fcd34d;
  color: #92400e;
  font-size: 0.85rem;
  line-height: 1.55;
}

.successBox {
  padding: 1.1rem;
  border-radius: 12px;
  background: #e6f7f5;
  border: 1px solid #86f2e4;
  color: #005049;
  font-size: 0.86rem;
  line-height: 1.55;
}

.helperFooter {
  margin-top: 1.25rem;
  padding-top: 1rem;
  border-top: 1px solid #dce9ff;
  font-size: 0.8rem;
  color: #444651;
  text-align: center;
}

.linkBtn {
  background: none;
  border: none;
  color: #00236f;
  font-weight: 700;
  cursor: pointer;
  padding: 0;
  font-size: 0.8rem;
  text-decoration: underline;
}
